import React from "react";
import "./loader.scss";
import { loaderImageBase64 } from "../assets/icons/BerriesBase64";
import Header from "./Header";
const Loader = ({ hasHeader = false, fadingOut = false }) => {
  return (
    <div className={`loader${fadingOut ? " loader--exit" : ""}`}>
      {hasHeader && <Header />}
      <img
        src={loaderImageBase64}
        alt="https://www.flaticon.com/free-icons/berries"
        className="animated-image"
      />
      <h1 className="loading-text">Loading</h1>
    </div>
  );
};
export default Loader;
